import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <h3>Takumi Tension</h3>
                        <p>Professional racquet stringing services</p>
                    </div>

                    <div className="footer-section">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><a href="/services">Services</a></li>
                            <li><a href="/products">Products</a></li>
                            <li><a href="/about">About</a></li>
                            <li><a href="/contact">Contact</a></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Contact</h4>
                        <p>60 Eu Tong Sen St, #01-17 Furama City Center, Singapore 059804</p>
                        <p>Phone: +6590688780</p>
                        <p>Email: takumitension@gmail.com</p>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; 2026 Takumi Tension. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;